'use client';
import { useUserStore } from '@/store/auth';
import {
  Box,
  Container,
  Link as MuiLink,
  IconButton,
  Stack,
  Collapse,
} from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { MdClose } from 'react-icons/md';
import { FaInstagram, FaTelegram } from 'react-icons/fa';
import { HiMenuAlt1 } from 'react-icons/hi';
import styled from '@emotion/styled';

const StyledStickyHeader = styled(Box)(({ theme }) => ({
  '&.sticky-header': {
    position: 'fixed',
    width: '100%',
    transition: 'top 0.3s',
    top: 0,
    left: 0,
    right: 0,
    mx: 'auto',
    zIndex: 1001,
  },
  '&.sticky-header.is-hidden': {
    top: '-100px',
  },
}));

const MainHeader = ({ authMode = false }) => {
  const auth = useUserStore(state => state.auth);
  const user = useUserStore(state => state.user);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [open, setOpen] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isClient, setIsClient] = useState(false);

  const toggleDrawer = newOpen => () => {
    setOpen(newOpen);
  };

  const DrawerList = (
    <Box
      sx={{
        bgcolor: 'secondary.main',
        width: '100%',
        height: '100dvh',
      }}
      role="presentation"
      onClick={toggleDrawer(false)}>
      <Container maxWidth="xl" sx={{ height: '50px', py: 1 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <IconButton color="primary">
            <MdClose size={30} />
          </IconButton>
          <MuiLink href="/" component={Link} variant="simpleLink">
            <Image
              src="/svg/dark-logo.svg"
              alt="سایت فروش دوره های آموزشی"
              width={36}
              height={36}
            />
          </MuiLink>
        </Box>
      </Container>
      <Container
        sx={{
          display: 'flex',
          // alignItems: "center",
          height: '100%',
        }}
        maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            alignItems: { xs: 'center', md: 'flex-start' },
            pt: 30,
            px: { xs: 0, md: 4 },
            height: '100%',
            width: '100%',
            flexDirection: 'column',
            gap: 5,
          }}>
          {isAuth ? (
            <Stack
              sx={{
                gap: 5,
                alignItems: { xs: 'center', sm: 'center', md: 'flex-start' },
              }}>
              <MuiLink href="/panel" component={Link} variant="menuLink">
                پنل کاربری
              </MuiLink>
              {/* <MuiLink href="/cart" component={Link} variant="menuLink">
                سبد خرید
              </MuiLink> */}
            </Stack>
          ) : (
            <MuiLink href="/auth" component={Link} variant="menuLink">
              ورود | ثبت نام
            </MuiLink>
          )}
          <MuiLink href="/blogs" component={Link} variant="menuLink">
            مقاله‌ها
          </MuiLink>
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              justifyContent: { xs: 'center', sm: 'center', md: 'flex-start' },
              // mt: 5,
            }}>
            <MuiLink
              href="https://t.me/doresaz"
              name="تلگرام سایت فروش دوره های آموزشی دوره‌ساز"
              component={Link}
              variant="menuLink"
              target="_blank">
              <FaTelegram size={30} />
            </MuiLink>
            <MuiLink
              href="https://instagram.com/dore-saz"
              name="اینستاگرام سایت فروش دوره های آموزشی دوره‌ساز"
              component={Link}
              variant="menuLink"
              target="_blank">
              <FaInstagram size={30} />
            </MuiLink>
            {/* <MuiLink href="/whatsapp" component={Link} variant="menuLink">
              <FaWhatsapp size={22} />
            </MuiLink> */}
          </Box>
        </Box>
      </Container>
      <Container
        maxWidth="xl"
        sx={{
          height: '50px',
          position: 'relative',
          display: { xs: 'none', sm: 'none', md: 'block' },
        }}>
        <Box sx={{ position: 'absolute', bottom: 150, right: 0 }}>
          <Image
            src="/svg/dark-logo.svg"
            alt="ساخت دوره آنلاین"
            width="250"
            height="250"
            style={{ opacity: 0.2 }}
          />
        </Box>
      </Container>
    </Box>
  );

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      if (prevScrollPos < 100) {
        document
          ?.querySelector('.sticky-header')
          ?.classList?.remove('is-hidden');
      } else if (!open) {
        document?.querySelector('.sticky-header')?.classList?.add('is-hidden');
      }
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [prevScrollPos, open]);

  useEffect(() => {
    if (auth()) {
      setIsAuth(true);
    } else {
      setIsAuth(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    setIsClient(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (!isClient) {
    return <></>;
  }

  return (
    <>
      <StyledStickyHeader className="sticky-header">
        <Collapse in={open}>{DrawerList}</Collapse>
        {!open && (
          <Container maxWidth="xl" sx={{ height: '70px' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: '100%',
              }}>
              <IconButton color="secondary" onClick={toggleDrawer(true)}>
                <HiMenuAlt1 size={30} />
              </IconButton>
              <MuiLink href="/" component={Link} variant="simpleLink">
                <Image
                  src={!authMode ? '/svg/light-logo.svg' : '/svg/dark-logo.svg'}
                  alt="ساخت دوره آنلاین"
                  width={36}
                  height={36}
                  priority
                />
              </MuiLink>
            </Box>
          </Container>
        )}
      </StyledStickyHeader>
    </>
  );
};

export default MainHeader;
